// Employees.js
import React, { useState, useEffect } from 'react';
import GSheetReader from 'g-sheets-api';
import './employees.css';
import NewNavbar from './Navbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Container, Row, Col } from 'react-bootstrap';

// const slides = [
//   { src: '/images/work.jpg', alt: 'Slide 1' },
//   { src: '/images/hair1.jpg', alt: 'Slide 2' },
//   { src: '/images/hair2.jpg', alt: 'Slide 3' },
//   { src: '/images/hair3.jpg', alt: 'Slide 4' },
//   { src: '/images/hair4.jpg', alt: 'Slide 5' },
//   { src: '/images/hair5.jpg', alt: 'Slide 6' },
//   { src: '/images/hair6.jpg', alt: 'Slide 7' },
//   { src: '/images/hair7.jpg', alt: 'Slide 8' },
//   { src: '/images/hair8.jpg', alt: 'Slide 9' },
//   { src: '/images/hair9.jpg', alt: 'Slide 10' },
// ];

function Employees() {
  const [employees, setEmployees] = useState([]);
  const [BarbersH1, setBarbersH1] = useState("");
  const [BarbersH2, setBarbersH2] = useState("");
  const [BarberSlides, setBarberSlides] = useState([]);


  // Fetch data from Google Sheets
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => {
        setBarbersH1(data.BarbersH1);
        setBarbersH2(data.BarbersH2);
        const employeeData = [];
        for (const [key, value] of Object.entries(data)) {
          if (key.endsWith("Barbers")) {
            employeeData.push({ name: key.slice(0, -7), imageUrl: value });
          }
        }
        setEmployees(employeeData);
        
        const slideData = [];
        for (const [key, value] of Object.entries(data)) {
          if (key.startsWith("BarberSwiper")) {
            console.log(key, value)
            slideData.push({ src: value, alt: key });
          }
        }
        setBarberSlides(slideData);
      })
      .catch(error => console.error('Error loading config:', error));
  }, []);

  return (
    <div>
      <NewNavbar />
      <Container>
        <h1>{BarbersH1}</h1>
        <Row>
          {/* Employees Grid */}
          <Col xs={12} md={8}>
            <div className="employees-grid">
              {employees.map((employee, index) => (
                <div key={index} className="employee-card">
                  <img src={employee.imageUrl} alt={employee.name} className="employee-photo" />
                  <h2>{employee.name}</h2>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        
        {/* Gallery Section */}
        <h2 className="gallery-title">{BarbersH2}</h2>
        <Row className="justify-content-center">
          <Col xs={12} md={10}>
            <Swiper
              spaceBetween={0}
              effect={'fade'}
              centeredSlides={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              modules={[EffectFade, Autoplay, Pagination]}
              className="mySwiper"
              style={{
                height: '80vh',
                width: '100%',
                maxWidth: '600px', // Limit max width for large screens
                margin: '0 auto', // Center align the Swiper
              }}
            >
              {BarberSlides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      overflow: 'hidden',
                    }}
                  >
                    <img src={slide.src} alt={`Slide ${index}`}
                      style={{
                        height: '100%',
                        width: 'auto',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Employees;
